import React from 'react';
import StockTablePage from '../../components/monitor/StockTablePage';

export default function RawMeat() {
  return <StockTablePage title="RAW MATERIAL IN LOW CARE" category="RAW MAT" />;
}
